import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const MahindraFinanceBikeEmi      = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the minimum loan amount for a Mahindra Finance bike loan?",
            "answer": "The minimum loan amount typically starts at ₹10,000, but it may vary depending on the specific loan product and your eligibility."
          },
          {
            "question": "How do I use the EMI calculator for Mahindra Finance bike loans?",
            "answer": "Simply enter your loan amount, interest rate, and loan tenure into the calculator, and it will instantly display your monthly EMI."
          },
          {
            "question": "Can the EMI calculator factor in processing fees or prepayments?",
            "answer": "Most EMI calculators, including ours, focus on principal and interest. However, you should consider additional fees manually when budgeting."
          },
          {
            "question": "What happens if I miss an EMI payment?",
            "answer": "Missing an EMI may lead to late payment charges, impact your credit score, and increase your outstanding loan amount."
          },
          {
            "question": "Can I prepay my Mahindra Finance bike loan?",
            "answer": "Yes, prepayment is allowed but may be subject to prepayment penalties. Always check the terms before proceeding."
          },
          {
            "question": "Does the EMI remain constant throughout the loan tenure?",
            "answer": "If you have a fixed interest rate loan, your EMI remains the same. For floating rate loans, EMIs may change with interest rate fluctuations."
          },
          {
            "question": "Is there a penalty for foreclosing the loan early?",
            "answer": "Mahindra Finance may charge a foreclosure penalty as per their loan terms."
          },
          {
            "question": "Can I change my loan tenure after sanction?",
            "answer": "Tenure changes are usually not allowed after loan sanctioning, but consult Mahindra Finance for specific cases."
          },
          {
            "question": "How can I reduce my EMI amount?",
            "answer": "You can reduce EMI by increasing the loan tenure or making a larger down payment."
          },
          {
            "question": "Will my credit score affect my bike loan EMI?",
            "answer": "Yes, a better credit score can lead to a lower interest rate and, thus, a lower EMI."
          },
          {
            "question": "How often can I use the EMI calculator?",
            "answer": "You can use it as many times as you want for free."
          },
          {
            "question": "Is the EMI calculator legally binding?",
            "answer": "No, it provides an estimate. Actual EMI may vary based on final loan sanction terms."
          },
          {
            "question": "What documents are needed for Mahindra Finance bike loans?",
            "answer": "Basic KYC documents, proof of income, and address proof are required."
          },
          {
            "question": "Can I apply for a bike loan online with Mahindra Finance?",
            "answer": "Yes, Mahindra Finance offers online loan application facilities for convenience."
          },
          {
            "question": "What factors affect the interest rate on my bike loan?",
            "answer": "Interest rates depend on your credit score, income, loan amount, and tenure."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
         {/* <title>Gold Loan EMI Calculator: Online Gold Loan EMI Calculator For - TheFinmaster</title>
        <meta  name='description' content='Home Loan EMI Calculator helps you calculate EMI of your housing loan required to pay for your dream home. Know about Online Home Loan EMI Calculator here! | TheFinmaster'/>
        <meta name='keywords' content='car loan emi calculator, car emi calculator, auto emi calculator, vehicle emi calculator, car finance emi calculator, automobile loan emi calculator, monthly emi calculator car loan' /> */}
        {/* <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" /> */}
      </Helmet>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 "> Mahindra Finance Bike Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4"> Mahindra Finance Bike Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Mahindra Finance Bike Loan Payments with TheFinMaster’s EMI Calculator
          </h1>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Managing your bike loan payments can be a complex task without the right tools. At TheFinMaster, we bring you the Mahindra Finance Bike Loan EMI Calculator, a comprehensive, easy-to-use digital tool designed to help you plan and manage your monthly installments effectively. Whether you are a first-time borrower or planning to refinance, this calculator will provide you with a clear view of your repayment structure so you can budget confidently and avoid surprises.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Bike Loan EMI?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An Equated Monthly Installment (EMI) is a fixed payment amount made by a borrower to a lender on a specified date each month. It comprises two components: the principal amount (the original loan) and the interest charged on the outstanding loan balance. In the case of a bike loan, the EMI represents your monthly financial obligation toward repaying the amount borrowed to purchase your bike. The EMI ensures that the loan is repaid within a stipulated tenure with consistent, manageable payments.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              For bike loans, EMIs play a crucial role as they allow borrowers to plan their finances, ensuring that the cost of the vehicle is spread over a period, reducing immediate financial burden while offering flexibility in repayment.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is Mahindra Finance Bike Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Mahindra Finance Bike Loan EMI Calculator is a smart, digital tool that calculates your monthly EMI for a bike loan sanctioned by Mahindra Finance. By inputting essential variables like loan amount, interest rate, and tenure, this calculator instantly provides you with the exact EMI amount you need to pay each month.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This calculator is specially tailored for Mahindra Finance's bike loan offerings, taking into account their specific interest rates, tenure options, and policies to give you the most accurate EMI estimates. It removes the guesswork involved in loan planning and empowers you to make informed decisions.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Mahindra Finance Bike Loan EMI Calculator?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Using TheFinMaster’s EMI calculator for Mahindra Finance bike loans offers several benefits:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Accurate Financial Planning:</strong> It helps you understand your monthly repayment commitments before applying for a loan, which assists in budgeting and managing your finances better.</li>
              <li><strong>Time-Saving and User-Friendly:</strong> No need for manual calculations or complex formulas. Just enter the numbers and get results instantly.</li>
              <li><strong>Customizable Inputs:</strong> Modify loan amount, interest rate, or tenure to see how changes affect your EMI and total repayment amount.</li>
              <li><strong>Avoid Hidden Surprises:</strong> Understand the impact of interest rates and tenure on your total loan cost, preventing last-minute shocks.</li>
              <li><strong>Comparison Ready:</strong> Calculate multiple scenarios to compare different loan plans and choose the best option for your needs.</li>
              <li><strong>Free and Accessible Anytime:</strong> Available online 24/7, with no hidden charges.</li>
            </ul>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Mahindra Finance Bike Loan EMI Calculator Work?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI calculator works by applying a standard mathematical formula to compute your monthly installment, considering the principal loan amount, interest rate, and loan tenure. The calculation assumes that the interest rate is fixed throughout the loan tenure and that payments are made monthly.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI Formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Loan Amount</li>
              <li>R = Monthly Interest Rate</li>
              <li>N = Loan Tenure in Months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example:</strong><br />
              Suppose you take a bike loan of ₹1,00,000 from Mahindra Finance at an interest rate of 10% per annum for a tenure of 24 months.<br />
              Loan Amount (P) = ₹1,00,000<br />
              Annual Interest Rate = 10%<br />
              Monthly Interest Rate (r) = 10/(12*100) = 0.00833<br />
              Tenure (n) = 24 months<br />
              Plugging these values into the formula gives you your monthly EMI amount. This calculation ensures you know exactly how much you need to pay every month for the next two years.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortisation Schedule?
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortisation schedule breaks down each monthly EMI payment into two parts — principal repayment and interest payment. At the beginning of the loan tenure, the interest portion is higher, and the principal repayment is lower. As you continue repaying, the interest component gradually decreases while the principal repayment increases, until the entire loan is paid off at the end of the tenure.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This schedule is important because it helps borrowers understand how their payments are allocated and how much interest they pay over time. It also allows for transparency in loan repayment, making it easier to track outstanding balances and plan prepayments if desired.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortisation Schedule for Mahindra Finance Bike Loan</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI Amount (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal Component (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest Component (₹)</th>
                    <th className="border px-4 py-2 text-left">Outstanding Principal (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">3,881</td>
                    <td className="border px-4 py-2">733</td>
                    <td className="border px-4 py-2">96,119</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">3,912</td>
                    <td className="border px-4 py-2">702</td>
                    <td className="border px-4 py-2">92,207</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">3,944</td>
                    <td className="border px-4 py-2">670</td>
                    <td className="border px-4 py-2">88,263</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">3,976</td>
                    <td className="border px-4 py-2">638</td>
                    <td className="border px-4 py-2">84,287</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,008</td>
                    <td className="border px-4 py-2">606</td>
                    <td className="border px-4 py-2">80,279</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,041</td>
                    <td className="border px-4 py-2">573</td>
                    <td className="border px-4 py-2">76,238</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,074</td>
                    <td className="border px-4 py-2">540</td>
                    <td className="border px-4 py-2">72,164</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,108</td>
                    <td className="border px-4 py-2">506</td>
                    <td className="border px-4 py-2">68,056</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,142</td>
                    <td className="border px-4 py-2">472</td>
                    <td className="border px-4 py-2">63,914</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,176</td>
                    <td className="border px-4 py-2">438</td>
                    <td className="border px-4 py-2">59,738</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,210</td>
                    <td className="border px-4 py-2">404</td>
                    <td className="border px-4 py-2">55,528</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">4,614</td>
                    <td className="border px-4 py-2">4,245</td>
                    <td className="border px-4 py-2">369</td>
                    <td className="border px-4 py-2">51,283</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Principal Component   (₹)</th>
          <th className="border px-4 py-2 text-left">Interest Component(₹)</th>
          <th className="border px-4 py-2 text-left">Outstanding Principal  (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
          ["1", "4,614", "3,881", "733", "96,119"],
          ["2", "4,614", "3,912", "702", "92,207"],
          ["3", "4,614", "3,944", "670", "88,263"],
          ["4", "4,614", "3,976", "638", "84,287"],
          ["5", "4,614", "4,008", "606", "80,279"],
          ["6", "4,614", "4,041", "573", "76,238"],
          ["7", "4,614", "4,074", "540", "72,164"],
          ["8", "4,614", "4,108", "506", "68,056"],
          ["9", "4,614", "4,142", "472", "63,914"],
          ["10", "4,614", "4,176", "438", "59,738"],
          ["11", "4,614", "4,210", "404", "55,528"],
          ["12", "4,614", "4,245", "369", "51,283"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
           ["1", "4,614", "3,881", "733", "96,119"],
           ["2", "4,614", "3,912", "702", "92,207"],
           ["3", "4,614", "3,944", "670", "88,263"],
           ["4", "4,614", "3,976", "638", "84,287"],
           ["5", "4,614", "4,008", "606", "80,279"],
           ["6", "4,614", "4,041", "573", "76,238"],
           ["7", "4,614", "4,074", "540", "72,164"],
           ["8", "4,614", "4,108", "506", "68,056"],
           ["9", "4,614", "4,142", "472", "63,914"],
           ["10", "4,614", "4,176", "438", "59,738"],
           ["11", "4,614", "4,210", "404", "55,528"],
           ["12", "4,614", "4,245", "369", "51,283"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold"> Principal Component  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Interest Component  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding Principal(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Note: Figures are illustrative and rounded for simplicity.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h1 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Bike Loan EMI
            </h1>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding the factors influencing your bike loan EMI can help you plan better and negotiate favorable loan terms. Here are the key factors:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Loan Amount:</strong> The higher the principal amount borrowed, the higher the EMI. Choosing a loan amount within your repayment capacity is essential to avoid financial stress.</li>
              <li><strong>Interest Rate:</strong> Even a slight change in the interest rate can have a significant impact on your monthly EMI and total repayment. Mahindra Finance offers competitive interest rates that vary based on credit profile and loan tenure.</li>
              <li><strong>Loan Tenure:</strong> Longer tenure reduces your EMI burden but increases the overall interest paid. Shorter tenure increases EMI but decreases total interest cost. Choosing the right tenure depends on your financial stability and goals.</li>
              <li><strong>Processing Fees:</strong> These upfront fees add to your loan cost and may affect your total outflow in the initial months.</li>
              <li><strong>Prepayments and Foreclosures:</strong> Making part-prepayments or foreclosing the loan early can reduce your outstanding principal and save on interest but may also incur penalties as per Mahindra Finance’s policies.</li>
              <li><strong>Credit Score:</strong> A higher credit score can qualify you for lower interest rates and better loan terms, thereby reducing your EMI.</li>
              <li><strong>Income & Employment Stability:</strong> Your repayment capacity based on income and employment status influences loan sanctioning and indirectly affects your EMI as the sanctioned amount and interest rate depend on these factors.</li>
            </ul>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h1 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h1>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default MahindraFinanceBikeEmi  ;
